const scrumBoardActions = {
    //BOARD
    CREATE_OR_UPDATE_BOARD_WATCHER: 'CREATE_OR_UPDATE_BOARD_WATCHER',
    CREATE_OR_UPDATE_BOARD: 'CREATE_OR_UPDATE_BOARD',
    EDIT_BOARD: 'EDIT_BOARD',
    DELETE_BOARD_WATCHER: 'DELETE_BOARD_WATCHER',
    DELETE_BOARD: 'DELETE_BOARD',
    SELECT_BOARD: 'SELECT_BOARD',

    //COLUMN
    CREATE_OR_UPDATE_COLUMN_WATCHER: 'CREATE_OR_UPDATE_COLUMN_WATCHER',
    CREATE_OR_UPDATE_COLUMN: 'CREATE_OR_UPDATE_COLUMN',
    EDIT_COLUMN: 'EDIT_COLUMN',
    CANCEL_EDIT_COLUMN: 'CANCEL_EDIT_COLUMN',
    DELETE_COLUMN_WATCHER: 'DELETE_COLUMN_WATCHER',
    DELETE_COLUMN: 'DELETE_COLUMN',
    RESET_COLUMN: 'RESET_COLUMN',
    MOVE_COLUMN_WATCHER: 'MOVE_COLUMN_WATCHER',
    SET_MOVED_COLUMN: 'SET_MOVED_COLUMN',
    DUBLICATE_COLUMN: 'DUBLICATE_COLUMN',

    //TASK
    CREATE_OR_UPDATE_TASK_WATCHER: 'CREATE_OR_UPDATE_TASK_WATCHER',
    CREATE_OR_UPDATE_TASK: 'CREATE_OR_UPDATE_TASK',
    EDIT_TASK: 'EDIT_TASK',
    CANCEL_EDIT_TASK: 'CANCEL_EDIT_TASK',
    DELETE_TASK_WATCHER: 'DELETE_TASK_WATCHER',
    DELETE_TASK: 'DELETE_TASK',
    RESET_TASK: 'RESET_TASK',
    MOVE_TASK_WATCHER: 'MOVE_TASK_WATCHER',
    SET_MOVED_TASK: 'SET_MOVED_TASK',
    DUBLICATE_TASK: 'DUBLICATE_TASK',

    // SEARCH
    SET_SEARCH_TEXT: 'SET_SEARCH_TEXT',

    // LOAD DATA
    LOAD_BOARDS_DATA_SAGA: 'LOAD_BOARDS_DATA_SAGA',
    LOAD_CURRENT_BOARD_DATA_SAGA: 'LOAD_CURRENT_BOARD_DATA_SAGA',
    SET_BOARDS_DATA: 'SET_BOARDS_DATA',
    SET_CURRENT_BOARD_DATA: 'SET_CURRENT_BOARD_DATA',

    // LABELS
    CREATE_OR_UPDATE_LABEL: 'CREATE_OR_UPDATE_LABEL',
    EDIT_LABEL: 'EDIT_LABEL',
    DELETE_LABEL: 'DELETE_LABEL',
    UPDATE_TASK: 'UPDATE_TASK',
    CREATE_NEW_TASK: 'CREATE_NEW_TASK',
    DELETE_TASK_ACTION: 'DELETE_TASK_ACTION',
    SET_DATA_INFO: 'SET_DATA_INFO',
    UPDATE_LIST_HASH_TAG: 'UPDATE_LIST_HASH_TAG',
    DELETE_LIST_TAG_UPDATE: 'DELETE_LIST_TAG_UPDATE',
    GET_DETAIL_TASK_BY_ID: 'GET_DETAIL_TASK_BY_ID',
    GET_DETAIL_TASK_BY_ID_DONE: 'GET_DETAIL_TASK_BY_ID_DONE',

    VISIBLE_MODAL_MEDIA: 'VISIBLE_MODAL_MEDIA',

    UPDATE_LIST_MEDIA: 'UPDATE_LIST_MEDIA',

    DELETE_LIST_MEDIA: 'DELETE_LIST_MEDIA',

    APPLY_TO_MEDIA: 'APPLY_TO_MEDIA',

    CREATE_NEW_REPORT: 'CREATE_NEW_REPORT',

    MOVE_CARD_REPORT: 'MOVE_CARD_REPORT',
    VISIBLE_MODAL_OBJECT: 'VISIBLE_MODAL_OBJECT',

    UPDATE_LIST_OBJECT: 'UPDATE_LIST_OBJECT',

    APPLY_TO_CURRENT_OBJECT: 'APPLY_TO_CURRENT_OBJECT',

    MAKE_STAR_FOR_TASK: 'MAKE_STAR_FOR_TASK',

    DELETE_STAR_FOR_TASK: 'DELETE_STAR_FOR_TASK',

    GET_LIST_TASK_STAR: 'GET_LIST_TASK_STAR',

    COMMENT_REPORT: 'COMMENT_REPORT',

    GET_LIST_COMMENT: 'GET_LIST_COMMENT',

    GET_LIST_COMMENT_DONE: 'GET_LIST_COMMENT_DONE',

    GET_LIST_CURRENT_EVENT: 'GET_LIST_CURRENT_EVENT',

    GET_LIST_CURRENT_EVENT_DONE: 'GET_LIST_CURRENT_EVENT_DONE',

    UPDATE_LIST_CURRENT_EVENT: 'UPDATE_LIST_CURRENT_EVENT',

    UPDATE_LIST_USER_COMMENT: 'UPDATE_LIST_USER_COMMENT',

    UPDATE_REPORT_REWORK: 'UPDATE_REPORT_REWORK',

    SENT_TASK_TO_USER: 'SENT_TASK_TO_END',

    UPDATE_PAGE_INDEX_BOARD: 'UPDATE_PAGE_INDEX_BOARD',

    UPDATE_TOTAL_PAGE: 'UPDATE_TOTAL_PAGE',

    SEARCH_TASK_INFO: 'SEARCH_TASK_INFO',

    GET_ACTIVITY_TASK: 'GET_ACTIVITY_TASK',

    GET_ACTIVITY_TASK_DONE: 'GET_ACTIVITY_TASK_DONE',

    RESET_LAST_ID_ACTIVITY_TASK: 'RESET_LAST_ID_ACTIVITY_TASK',

    UPDATE_STATUS_TASK: 'UPDATE_STATUS_TASK',

    UPDATE_SCORE_REPORT: 'UPDATE_SCORE_REPORT',

    GET_LIST_RANKING_IN_TASK: 'GET_LIST_RANKING_IN_TASK',

    GET_LIST_RANKING_IN_TASK_DONE: 'GET_LIST_RANKING_IN_TASK_DONE',

    GET_LIST_TASK_BY_HASH_TAG: 'GET_LIST_TASK_BY_HASH_TAG',

    VISIBLE_MODAL_CREATE_TASK: 'VISIBLE_MODAL_CREATE_TASK',

    GET_LIST_ACTION_OF_USER: 'GET_LIST_ACTION_OF_USER',

    UPDATE_LIST_CURRENT_USER_OF_TASK: 'UPDATE_LIST_CURRENT_USER_OF_TASK',

    GET_LIST_TASK_ABOUT_TIME: 'GET_LIST_TASK_ABOUT_TIME',

    GET_LIST_TASK_MERGE_OPTION: 'GET_LIST_TASK_MERGE_OPTION',

    GET_LIST_HASH_TAG_ALL: 'GET_LIST_HASH_TAG_ALL',

    GET_LIST_HASH_TAG_ALL_DONE: 'GET_LIST_HASH_TAG_ALL_DONE',

    VISIBLE_MODAL_EVENT: 'VISIBLE_MODAL_EVENT',

    SEARCH_USER_BY_TEXT: 'SEARCH_USER_BY_TEXT',

    SEARCH_USER_BY_TEXT_DONE: 'SEARCH_USER_BY_TEXT_DONE',

    UPDATE_CURRENT_USER_PICKUP: 'UPDATE_CURRENT_USER_PICKUP',

    GET_LIST_CURRENT_USER: 'GET_LIST_CURRENT_USER',
    
    GET_LIST_CURRENT_USER_DONE: 'GET_LIST_CURRENT_USER_DONE',

    UPDATE_CURRENT_USER_PICK_UP: 'UPDATE_CURRENT_USER_PICK_UP',

    setCurrentUserPickUp: data =>({
        type: scrumBoardActions.UPDATE_CURRENT_USER_PICK_UP,
        payload: { data },
    }),

    getListCurrentUser: lstuser =>({
        type: scrumBoardActions.GET_LIST_CURRENT_USER,
        payload: { lstuser },
    }),
    getListCurrentUserDone: data =>({
        type: scrumBoardActions.GET_LIST_CURRENT_USER_DONE,
        payload: { data },
    }),
    updateCurrentUserPickup: data =>({
        type: scrumBoardActions.UPDATE_CURRENT_USER_PICKUP,
        payload: { data },
    }),

    searchUserByText : text =>({
        type: scrumBoardActions.SEARCH_USER_BY_TEXT,
        payload: { text },
    }),
    searchUserByTextDone : data =>({
        type: scrumBoardActions.SEARCH_USER_BY_TEXT_DONE,
        payload: { data },
    }),


    visibleModalEvent: visible => ({
        type: scrumBoardActions.VISIBLE_MODAL_EVENT,
        payload: { visible },
    }),

    getListHashTagAll: () => ({
        type: scrumBoardActions.GET_LIST_HASH_TAG_ALL,
    }),
    getListHashTagAllDone: data => ({
        type: scrumBoardActions.GET_LIST_HASH_TAG_ALL_DONE,
        payload: { data },
    }),

    getListTaskMergeOption: (page_number, page_size, body) => ({
        type: scrumBoardActions.GET_LIST_TASK_MERGE_OPTION,
        payload: {
            page_number,
            page_size,
            body,
        },
    }),

    getListTaskAboutTime: (page_number, page_size, begin_time, end_time) => ({
        type: scrumBoardActions.GET_LIST_TASK_ABOUT_TIME,
        payload: {
            page_number,
            page_size,
            begin_time,
            end_time,
        },
    }),

    updateListCurrentUserInfo: data => ({
        type: scrumBoardActions.UPDATE_LIST_CURRENT_USER_OF_TASK,
        payload: {
            data,
        },
    }),

    visibleModalCreateTaskAction: visible => ({
        type: scrumBoardActions.VISIBLE_MODAL_CREATE_TASK,
        payload: {
            visible,
        },
    }),

    getListTaskByHashTag: (page_number, page_size, hashtag) => ({
        type: scrumBoardActions.GET_LIST_TASK_BY_HASH_TAG,
        payload: {
            page_number,
            page_size,
            hashtag,
        },
    }),

    getListRanking: tid => ({
        type: scrumBoardActions.GET_LIST_RANKING_IN_TASK,
        payload: {
            tid,
        },
    }),
    getListRankingDone: data => ({
        type: scrumBoardActions.GET_LIST_RANKING_IN_TASK_DONE,
        payload: {
            data,
        },
    }),

    updateScoreReport: (rid, score) => ({
        type: scrumBoardActions.UPDATE_SCORE_REPORT,
        payload: {
            rid,
            score,
        },
    }),

    updateStatusTask: (task_id, status) => ({
        type: scrumBoardActions.UPDATE_STATUS_TASK,
        payload: {
            task_id,
            status,
        },
    }),

    resetLastIdActivity: () => ({
        type: scrumBoardActions.RESET_LAST_ID_ACTIVITY_TASK,
    }),

    getActivityTask: (tid, page_number, page_size) => ({
        type: scrumBoardActions.GET_ACTIVITY_TASK,
        payload: {
            tid,
            page_number,
            page_size,
        },
    }),
    getActivityTaskDone: data => ({
        type: scrumBoardActions.GET_ACTIVITY_TASK_DONE,
        payload: {
            data,
        },
    }),

    searchTaskInfo: (page_number, text, status) => ({
        type: scrumBoardActions.SEARCH_TASK_INFO,
        payload: {
            page_number,
            text,
            status,
        },
    }),

    updateTotalPage: data => ({
        type: scrumBoardActions.UPDATE_TOTAL_PAGE,
        payload: {
            data,
        },
    }),

    updatePageIndexBoard: index => ({
        type: scrumBoardActions.UPDATE_PAGE_INDEX_BOARD,
        payload: {
            index,
        },
    }),

    sentTaskToUser: tid => ({
        type: scrumBoardActions.SENT_TASK_TO_USER,
        payload: {
            tid,
        },
    }),

    updateReportReWork: (fid, body) => ({
        type: scrumBoardActions.UPDATE_REPORT_REWORK,
        payload: {
            fid,
            body,
        },
    }),

    updateListUserComment: data => ({
        type: scrumBoardActions.UPDATE_LIST_USER_COMMENT,
        payload: {
            data,
        },
    }),

    updateListCurrentEvent: data => ({
        type: scrumBoardActions.UPDATE_LIST_CURRENT_EVENT,
        payload: {
            data,
        },
    }),
    getListCurrentEvent: lst => ({
        type: scrumBoardActions.GET_LIST_CURRENT_EVENT,
        payload: {
            lst,
        },
    }),
    getListCurrentEventDone: data => ({
        type: scrumBoardActions.GET_LIST_CURRENT_EVENT_DONE,
        payload: {
            data,
        },
    }),

    getListCommentReport: rid => ({
        type: scrumBoardActions.GET_LIST_COMMENT,
        payload: {
            rid,
        },
    }),
    getListCommentReportdone: (data, rid, total) => ({
        type: scrumBoardActions.GET_LIST_COMMENT_DONE,
        payload: {
            data,
            rid,
            total,
        },
    }),

    commentReport: body => ({
        type: scrumBoardActions.COMMENT_REPORT,
        payload: {
            body,
        },
    }),

    getListTaskStar: (page_number, page_size) => ({
        type: scrumBoardActions.GET_LIST_TASK_STAR,
        payload: {
            page_number,
        },
    }),
    deleteStarForTask: taskid => ({
        type: scrumBoardActions.DELETE_STAR_FOR_TASK,
        payload: {
            taskid,
        },
    }),

    makeStarForTask: taskid => ({
        type: scrumBoardActions.MAKE_STAR_FOR_TASK,
        payload: {
            taskid,
        },
    }),

    applyToCurrentObject: data => ({
        type: scrumBoardActions.APPLY_TO_CURRENT_OBJECT,
        data,
    }),

    updateListObject: (data, ispush) => ({
        type: scrumBoardActions.UPDATE_LIST_OBJECT,
        payload: {
            data,
            ispush,
        },
    }),

    showModalObject: visible => ({
        type: scrumBoardActions.VISIBLE_MODAL_OBJECT,
        payload: {
            visible,
        },
    }),

    moveCardReport: (
        fromIndex,
        fromColumn,
        toIndex,
        toColumn,
        report_id,
        task_id
    ) => ({
        type: scrumBoardActions.MOVE_CARD_REPORT,
        payload: {
            fromIndex,
            fromColumn,
            toIndex,
            toColumn,
            report_id,
            task_id,
        },
    }),
    createNewReport: body => ({
        type: scrumBoardActions.CREATE_NEW_REPORT,
        payload: {
            body,
        },
    }),

    applyToMedia: data => ({
        type: scrumBoardActions.APPLY_TO_MEDIA,
        data,
    }),
    deleteListMedia: () => ({
        type: scrumBoardActions.DELETE_LIST_MEDIA,
    }),

    updateListMedia: (data, ispush) => ({
        type: scrumBoardActions.UPDATE_LIST_MEDIA,
        payload: {
            data,
            ispush,
        },
    }),
    showModalMedia: visible => ({
        type: scrumBoardActions.VISIBLE_MODAL_MEDIA,
        payload: {
            visible,
        },
    }),
    getDetailTaskById: (id, isUpdate) => ({
        type: scrumBoardActions.GET_DETAIL_TASK_BY_ID,
        payload: {
            id,
            isUpdate,
        },
    }),
    getDetailTaskByIdDone: data => ({
        type: scrumBoardActions.GET_DETAIL_TASK_BY_ID_DONE,
        payload: {
            data,
        },
    }),

    deleteListTagUpdate: () => ({
        type: scrumBoardActions.DELETE_LIST_TAG_UPDATE,
    }),

    updateHashTag: data => ({
        type: scrumBoardActions.UPDATE_LIST_HASH_TAG,
        payload: {
            data,
        },
    }),

    setDataInfo: data => ({
        type: scrumBoardActions.SET_DATA_INFO,
        payload: {
            data,
        },
    }),

    deleteTaskAction: (id, history) => ({
        type: scrumBoardActions.DELETE_TASK_ACTION,
        payload: {
            id,
            history,
        },
    }),
    createNewTask: (body, history) => ({
        type: scrumBoardActions.CREATE_NEW_TASK,
        payload: {
            body,
            history,
        },
    }),
    // Load Data Actions
    updateTask: (body, taskid, history) => ({
        type: scrumBoardActions.UPDATE_TASK,
        payload: {
            body,
            taskid,
            history,
        },
    }),

    getListBoard: (page_number, isGetAll) => ({
        type: scrumBoardActions.LOAD_BOARDS_DATA_SAGA,
        payload: {
            page_number,
            isGetAll,
        },
    }),

    setBoardsData: boards => ({
        type: scrumBoardActions.SET_BOARDS_DATA,
        payload: boards,
    }),

    boardRenderWatcher: boardId => ({
        type: scrumBoardActions.LOAD_CURRENT_BOARD_DATA_SAGA,
        payload: boardId,
    }),

    setBoardData: boardData => ({
        type: scrumBoardActions.SET_CURRENT_BOARD_DATA,
        payload: boardData,
    }),
    ////
    // Task Actions
    createOrUpdateTaskWatcher: payload => {
        return {
            type: scrumBoardActions.CREATE_OR_UPDATE_TASK_WATCHER,
            payload,
        }
    },
    createOrUpdateTask: payload => {
        return {
            type: scrumBoardActions.CREATE_OR_UPDATE_TASK,
            payload,
        }
    },

    editTask: payload => {
        return {
            type: scrumBoardActions.EDIT_TASK,
            payload,
        }
    },

    cancelEditTask: payload => {
        return {
            type: scrumBoardActions.CANCEL_EDIT_TASK,
            payload,
        }
    },

    deleteTaskWatcher: payload => {
        return {
            type: scrumBoardActions.DELETE_TASK_WATCHER,
            payload,
        }
    },
    deleteTask: payload => {
        return {
            type: scrumBoardActions.DELETE_TASK,
            payload,
        }
    },

    resetTask: payload => {
        return {
            type: scrumBoardActions.RESET_TASK,
            payload,
        }
    },

    setSearchText: payload => {
        return {
            type: scrumBoardActions.SET_SEARCH_TEXT,
            payload,
        }
    },

    moveTaskWatcher: payload => {
        return {
            type: scrumBoardActions.MOVE_TASK_WATCHER,
            payload,
        }
    },
    setMovedTask: payload => {
        return {
            type: scrumBoardActions.SET_MOVED_TASK,
            payload,
        }
    },

    // Column Actions
    createOrUpdateColumnWatcher: payload => {
        return {
            type: scrumBoardActions.CREATE_OR_UPDATE_COLUMN_WATCHER,
            payload,
        }
    },
    createOrUpdateColumn: payload => {
        return {
            type: scrumBoardActions.CREATE_OR_UPDATE_COLUMN,
            payload,
        }
    },

    editColumn: payload => {
        return {
            type: scrumBoardActions.EDIT_COLUMN,
            payload,
        }
    },

    cancelEditColumn: payload => {
        return {
            type: scrumBoardActions.CANCEL_EDIT_COLUMN,
            payload,
        }
    },

    deleteColumnWatcher: payload => {
        return {
            type: scrumBoardActions.DELETE_COLUMN_WATCHER,
            payload,
        }
    },
    deleteColumn: payload => {
        return {
            type: scrumBoardActions.DELETE_COLUMN,
            payload,
        }
    },

    resetColumn: payload => {
        return {
            type: scrumBoardActions.RESET_COLUMN,
            payload,
        }
    },
    moveColumnWatcher: payload => {
        return {
            type: scrumBoardActions.MOVE_COLUMN_WATCHER,
            payload,
        }
    },
    setMovedColumn: payload => {
        return {
            type: scrumBoardActions.SET_MOVED_COLUMN,
            payload,
        }
    },

    // Board Actions
    createOrUpdateBoardWatcher: board => {
        return {
            type: scrumBoardActions.CREATE_OR_UPDATE_BOARD_WATCHER,
            payload: board,
        }
    },
    createOrUpdateBoard: board => {
        return {
            type: scrumBoardActions.CREATE_OR_UPDATE_BOARD,
            payload: board,
        }
    },
    editBoard: board => {
        return {
            type: scrumBoardActions.EDIT_BOARD,
            payload: board,
        }
    },
    deleteBoardWatcher: boardID => {
        return {
            type: scrumBoardActions.DELETE_BOARD_WATCHER,
            payload: boardID,
        }
    },
    deleteBoard: boardID => {
        return {
            type: scrumBoardActions.DELETE_BOARD,
            payload: boardID,
        }
    },

    // Label Actions
    createOrUpdateLabel: label => {
        return {
            type: scrumBoardActions.CREATE_OR_UPDATE_LABEL,
            payload: label,
        }
    },
    editLabel: label => {
        return {
            type: scrumBoardActions.EDIT_LABEL,
            payload: label,
        }
    },
    deleteLabel: labelID => {
        return {
            type: scrumBoardActions.DELETE_LABEL,
            payload: labelID,
        }
    },
}

export default scrumBoardActions
